// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import store from './store'
import VueCookie from 'vue-cookie'
import axiosApi from './api/axios.js'
import '@/assets/css/style.css' // read公共样式
import '@/assets/css/base.css' // 基础公共样式
import '@/assets/css/card.css' // card公共样式
import '@/assets/icon/read/iconfont.css' // 青音共读会的图标
import '@/assets/icon/better/iconfont.css' // better的图标
import wx from 'weixin-js-sdk'
import wxShare from './assets/js/share.js'
import '@/assets/js/base/rem.js'
import utils from '@/assets/js/utils.js'
import ba from 'vue-ba'
import VueClipboard from 'vue-clipboard2'
import 'jquery'
import ant from 'ant-design-vue'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import gradients from '@/components/base/gradients.vue'
import hoverMenu from '@/components/base/hover_menu.vue'
import scrollList from '@/components/scroll.vue'
import LyTab from 'ly-tab'
import '@vant/touch-emulator'
import hls from 'videojs-contrib-hls'
import 'video.js/dist/video-js.css'

Vue.use(LyTab)
Vue.use(ant)
Vue.use(axiosApi)
Vue.use(VueCookie)
Vue.use(VueAwesomeSwiper)
Vue.use(ba, '44b29c1bdfb2a63ae7ba8f27e4ffeee6')
Vue.use(ba, { siteId: '44b29c1bdfb2a63ae7ba8f27e4ffeee6' })
Vue.use(VueClipboard)
Vue.config.productionTip = false
Vue.component('hover-menu', hoverMenu)
Vue.component('scroll-list', scrollList)
Vue.component('gradients', gradients)
Vue.use(hls)
// 挂载wx
Vue.prototype.$wx = wx
Vue.prototype.$wxShare = wxShare
Vue.prototype.$http = axios
Vue.prototype.utils = utils
axios.defaults.withCredentials = true // 让ajax携带cookie
/* eslint-disable no-new */
// 格式化时间
Vue.filter('dataFormat', function (value, fmt) {
  let getDate = new Date(value.replace(/-/g, '/'))
  let o = {
    'M+': getDate.getMonth() + 1,
    'd+': getDate.getDate(),
    'h+': getDate.getHours(),
    'm+': getDate.getMinutes(),
    's+': getDate.getSeconds(),
    'q+': Math.floor((getDate.getMonth() + 3) / 3),
    'S': getDate.getMilliseconds()
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (getDate.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  for (let k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
    }
  }
  return fmt
})
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js